module.exports = __webpack_public_path__ + "img/FUpJKZ8aJSo.9be6e922.jpg";